import Mock from 'mockjs'
import './modules/homeApi.js'

Mock.setup({
  timeout: '300-400', // 设置相应时间
})
